import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';

import { ThemeService } from '../../core/services/theme.service';

/**
 * Light/dark switch for the toolbar.
 *
 * The icon shows the theme currently in effect — a sun in light mode, a moon in dark — while the
 * accessible label and tooltip describe what a click will do, so the control is unambiguous either
 * way round. It is a single button rather than two radios: there are only two states, and a button
 * carrying `aria-pressed` is what a screen reader expects for that.
 */
@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  private readonly themes = inject(ThemeService);

  readonly isDark = this.themes.isDark;

  /** What the button will do, for the label and the tooltip. */
  readonly action: Signal<string> = computed(() => `Switch to ${this.isDark() ? 'light' : 'dark'} theme`);

  toggle(): void {
    this.themes.toggle();
  }
}
